module.exports = "<p>\n  sales-analytics works!\n</p>\n"